// extracted by mini-css-extract-plugin
export default {"imageWrapper":"EH-z","hovered":"FH-z","hoverImage":"GH-z","mainImage":"HH-z","imageNoBackground":"IH-z","fullSizeImage":"JH-z"};